import * as fetcher from '@hydra/utils/fetcher';

export async function getOverviewData (searchParams) {
  return fetcher.get('/api/overview', { searchParams }).json();
}

export async function getOverviewReviewsData (searchParams) {
  return fetcher.get('/api/overview/reviews', { searchParams }).json();
}

export async function getOverviewProjectsData (searchParams) {
  return fetcher.get('/api/overview/projects', { searchParams }).json();
}

export async function getProjectCount () {
  return fetcher.get('/api/overview/projectCount').json();
}
